import axios from "axios";
import { z } from "zod";
import { toast } from "../../components/ui/use-toast";
import { CircleCheckBig } from "lucide-react";
import { formatDateToYYYYMMDDLocal } from "../../utils/dateUtils";
const baseUrl = process.env.REACT_APP_SERVER_URL;

export const getAllEvents = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/events`);
    return { events: response.data.events };
  } catch (error) {
    console.error(error);
  }
};

export const handleCreateEvent = async (
  formData: any,
  setFormData: Function,
  EventCreateSchema: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const newsFormData = new FormData();

    for (const key in formData) {
      if (formData.hasOwnProperty(key) && key !== "image") {
        if (formData[key] !== undefined && formData[key] !== null) {
          if (Array.isArray(formData[key])) {
            newsFormData.append(key, JSON.stringify(formData[key]));
          } else if (key === "date" && formData[key] instanceof Date) {
            const dateStr = formatDateToYYYYMMDDLocal(formData[key]);
            newsFormData.append(key, dateStr);
          } else {
            newsFormData.append(key, formData[key]);
          }
        }
      }
    }

    if (formData.image && Array.isArray(formData.image)) {
      formData.image.forEach((image: any, index: any) => {
        newsFormData.append(`image`, image.file);
      });
    }

    const response = await axios.post(
      `${baseUrl}/api/events/`,
      newsFormData,
      config
    );
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">{response.data.msg}</span>
        </div>
      ),
    });
    navigate("/admin-dashboard/evenements");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const getEventBySlug = async (slug: string) => {
  try {
    const response = await axios.get(`${baseUrl}/api/events/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const handleUpdateEvent = async (
  id: number,
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("description", formData.description);

    if (formData.date instanceof Date) {
      const dateStr = formatDateToYYYYMMDDLocal(formData.date);
      formDataToSend.append("date", dateStr);
    } else {
      formDataToSend.append("date", formData.date);
    }

    if (formData.image) {
      formDataToSend.append("image", formData.image[0].file);
    }

    const response = await axios.patch(
      `${baseUrl}/api/events/${id}`,
      formDataToSend,
      config
    );

    toast({
      variant: "destructive",
      title: "Opération réussie.",
      description: response.data.msg,
      className: "bg-green-500 border border-green-500",
    });
    navigate("/admin-dashboard/evenements");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const deleteEvent = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    const response = await axios.delete(`${baseUrl}/api/events/${id}`, config);
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getEventById = async (id: number) => {
  try {
    const response = await axios.get(`${baseUrl}/api/events/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
